import i18n from "../i18n";
import { Button, Group } from "@mantine/core";
import React from "react";
import _ from "lodash";
import AllowanceTerminateButton from "./allowanceTerminateButton";
import AllowanceReactiveButton from "./allowanceReactiveButton";
import ActionPermissionGate from "./actionPermissionGate";
import { useHideFormActionList } from "../hooks/useHideFormActionList";

const AllowanceActionList = ({ form }) => {
  const hideActionList = useHideFormActionList(form);
  const status = _.get(form.values, "status");
  const id = _.get(form.values, "_id");

  if (hideActionList) return null;

  return (
    <Group mt={10}>
      {status !== "COMPLETED" && (
        <ActionPermissionGate entity="allowance" action="terminate">
          <AllowanceTerminateButton form={form} id={id} />
        </ActionPermissionGate>
      )}

      {status !== "COMPLETED" && (
        <ActionPermissionGate entity="allowance" action="reactive">
          <AllowanceReactiveButton form={form} id={id} />
        </ActionPermissionGate>
      )}

      {status === "COMPLETED" && (
        <Button variant="outline" fullWidth>{i18n.t("Completed")}</Button>
      )}
    </Group>
  );
};

export default AllowanceActionList;
